angular.module('tgaAdmin').controller('HelpController', [
  '$scope',
  '$state',
  '$timeout',
  'supportService',
  'userService',
  '$translate',
  function ($scope, $state, $timeout, supportService, userService, $translate) {
    $scope.data = {
      subjects: ['Technical Support', 'General Question'],
      alerts: [],
    };

    $scope.viewmodel = {
      subject: null,
      name: null,
      email: null,
      message: null,
      image: null,
    };

    $scope.activeTab = 1;

    $scope.initialize = function () {
      $timeout(() => {
        $scope.resetFields();
      });
    };

    $scope.resetFields = function () {
      $translate('help.default_message').then((message) => {
        $scope.viewmodel = {
          subject: null,
          name: null,
          email: null,
          message,
          image: null,
        };
      });
    };

    $scope.actions = {
      submit(form) {
        if ($scope.timer) {
          $timeout.cancel($scope.timer);
        }

        if (form.$invalid) {
          $scope.actions.createAlert(
            `<span class="fa fa-exclamation-triangle"></span> ${$translate
              .instant('common.check_form_for_errors')
              .toString()}`,
            'danger',
          );
          return;
        }

        form.processing = true;
        const data = angular.copy($scope.viewmodel);
        data.message = data.message.replace(/(?:\r\n|\r|\n)/g, '<br>');
        supportService.sendMessage(data).then(
          () => {
            $scope.actions.createAlert(
              '<span class="fa fa-check"></span> Your support request has been sent. We will get back to you shortly.',
              'success',
            );

            form.processing = false;
            form.submitted = false;
            $scope.resetFields();
          },
          (error) => {
            $scope.actions.createAlert(
              `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
              'danger',
            );
            form.processing = false;
            form.submitted = false;
          },
        );
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });

        $scope.timer = $timeout(() => {
          $scope.data.alerts.splice($scope.data.alerts.length - 1, 1);
        }, 5000);
      },
      checkImage(image) {
        // console.log(image)
        $scope.data.alerts = [];

        if (!image) {
          $scope.actions.createAlert('<span class="fa fa-exclamation-triangle"></span> Invalid file format.', 'danger');
          return;
        }

        const extension = /(?:\.([^.]+))?$/;
        const ext = extension.exec(image.filename)[1];
        const allowed = /jpeg|jpg|gif|png|pdf/i;
        if (!allowed.test(ext)) {
          image.base64 = null;
          // image.invalid_type = true;
          $scope.actions.createAlert('<span class="fa fa-exclamation-triangle"></span> Invalid file format.', 'danger');
          return;
        }

        // Don't allow images larger than 5MB.
        if (image.filesize > 5242880) {
          image.base64 = null;
          // image.invalid_size = true;
          $scope.actions.createAlert(
            '<span class="fa fa-exclamation-triangle"></span> Image files cannot be more than 5 MB in size.',
            'danger',
          );
        }
      },
      linkClick($event) {
        const target = angular.element($event.target);
        const child = target.parent().find('span');
        const isPlus = child.hasClass('fa-plus');
        const oldClass = isPlus ? 'fa-plus' : 'fa-minus';
        const newClass = isPlus ? 'fa-minus' : 'fa-plus';
        child.removeClass(oldClass);
        child.addClass(newClass);
      },
      tutorial() {
        userService.setData({
          intro1: false,
          intro2: false,
        });
        $state.go('v1.games');
      },
    };

    $scope.initialize();
  },
]);
